import "./LoginScreen.css";
import { ImagePath } from "../helper/ImagePath";
import { Col, Container, Row, Image } from "react-bootstrap";
import React, { useEffect, useId, useState } from "react";
import { useNavigat, useLocatione, useLocation, useNavigate } from "react-router-dom";
import { useHistory } from 'react-router-dom'
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { emptyTotalEarning, postLogin, postOTP, removeLoginData, storeUserId } from "../store/actions";
import { setUserCode } from "../helper/helpingMethods";
import loaderImg from '../../src/assets/gif/pattern.gif';
import axios from "axios";
import OTPInput from "react-otp-input";
import { colors } from "@mui/material";
import OtpInput from 'react-otp-input';
import incrpted from "../helper/incrpted";
import ReactGA from "react-ga4";
import { analytics } from "./FireBaseConsole";
// import { logEvent } from "firebase/analytics";
import { event } from "jquery";
import { clearAllCookies } from "../helper/cookieService";

import Cookies from 'js-cookie';
import { Alert } from "bootstrap";

function LoginScreen() {
  const [userId, setUserId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [rememberMe, setRememberMe] = useState(false);
  const [loginData, setLoginData] = useState([]);
  const [checkCondition, setCheckCondition] = useState(0)
  const [errorId, setErrorId] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [error, setError] = useState("");
  const [otpResponse, setOtpResponse] = useState("")
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [secondsRemaining, setSecondsRemaining] = useState(30);
  const [timerStart, setTimerStart] = useState(false);

  const { loginDeatil } = useSelector((state) => ({
    loginDeatil: state.logingData,
  }));

  const userDetails = loginDeatil?.logingData?.mobile;
  const loginStatos = loginDeatil?.loginData
  const handleUserId = (e) => {
    setUserId(e.target.value);
    setErrorId("");
    if (!/^[a-zA-Z0-9\-]*$/.test(e.target.value)) {
      setErrorId("Partner code can only contain letters, numbers, and hyphens");
    } else {
      setErrorId(""); // Clear error if valid
    }
  };

  const handleOtp = (e) => {
    setOtp(e.target.value);
    setOtpError("");
  };

  const handleContinue = async () => {
    setErrorId("");
    dispatch(removeLoginData());
    if (!userId) {
      setErrorId("Please enter partner code");
      return;
    }
    if (!/^[a-zA-Z0-9\-]+$/.test(userId)) {
      setErrorId("Partner code can only contain letters, numbers, and hyphens");
      return; // Stop further execution
    }

    if (userId) {
      dispatch(
        postLogin({
          username: userId,
        })
      );
      // logEvent(analytics, 'Login_btn_click', {
      //   page_title: "Login Page",
      //   screen_name: "LoginScreen",
      //   event: "login",
      // });
      setSecondsRemaining(30);
      setTimerStart(true)
    }
  };


  // useEffect(() => {
  //   if (timerStart == true) {
  //     const timer = setInterval(() => {
  //       if (secondsRemaining > 0) {
  //         setSecondsRemaining((prevSeconds) => prevSeconds - 1);
  //       } else {
  //         clearInterval(timer);
  //       }
  //     }, 1000);

  //     // Cleanup on component unmount
  //     return () => clearInterval(timer);
  //   }
  // }, [secondsRemaining, timerStart]);
  useEffect(() => {
    // handleDeleteCookies();
    clearAllCookies();



    if (timerStart && secondsRemaining > 0) {
      const timer = setInterval(() => {
        setSecondsRemaining((prevSeconds) => prevSeconds - 1);
      }, 1000);

      // Cleanup timer on unmount
      return () => clearInterval(timer);
    }

    // If timer reaches 0, stop it
    if (secondsRemaining === 0) {
      setTimerStart(false); // Stop the countdown
    }
  }, [secondsRemaining, timerStart]);



  // const data = JSON.parse(localStorage.getItem("userData"));
  const data = JSON.parse(sessionStorage.getItem("userData"));
  useEffect(() => {
    if (data?.status === true) {
      // setLoginData(data?.data?.mobile);
      localStorage.setItem("Slider", JSON.stringify("1"));
      // setUserCode(data?.data?.[0].username);
      navigate("/console")
      // navigate("/IncomeScreen")
    }
  }, [data])

  // useEffect(() => {
  //   const searchParamsString = location.search.substring(1);
  //   const paramsArray = searchParamsString.split('&');
  //   let userName, password;
  //   console.log("check the url get in api EEE  ", paramsArray)
  //   paramsArray.forEach(param => {
  //     const [key, value] = param.split(':');
  //     if (key === 'UserName') {
  //       userName = value;
  //     }
  //   });
  //   console.log("check the url get in api EEE  loginn  ", userName)

  //   if (userName) {
  //     const valueToSet = (userName) ? 1 : 0;
  //     localStorage.setItem('myValue', valueToSet.toString());
  //     localStorage.setItem("Slider", JSON.stringify("1"));
  //     checkTokenAppUser({ userName })
  //   }
  // }, [location.search])


  useEffect(() => {
    let searchParamsString = location.search.substring(1); // Remove "?" from URL
    searchParamsString = searchParamsString.replace("UserName:", "UserName="); // Replace ":" with "="

    const params = new URLSearchParams(searchParamsString);
    let userName = params.get("UserName"); // Get the UserName value

    console.log("Extracted UserName:", userName);

    if (userName) {
      localStorage.setItem('myValue', "1");
      localStorage.setItem("Slider", JSON.stringify("1"));
      checkTokenAppUser({ userName });
    }
  }, [location.search]);


  const checkTokenAppUser = async ({ userName }) => {
    const url = `https://apinew.bigul.co/api/v1/verify-token`;
    const payload = { token: userName };
    const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImNkMDUxZGExMDc2MDg1NzVkOGE2NDZhZWM5ZGM0NTI1NGRiYjE4ZjM0OThiOThhZDYwYWI2MDI1ZGU2MjRlZDJhOGIxZTk5YTQ2OTk4NDJiIn0.eyJhdWQiOiI1IiwianRpIjoiY2QwNTFkYTEwNzYwODU3NWQ4YTY0NmFlYzlkYzQ1MjU0ZGJiMThmMzQ5OGI5OGFkNjBhYjYwMjVkZTYyNGVkMmE4YjFlOTlhNDY5OTg0MmIiLCJpYXQiOjE2ODk4NTM5NDYsIm5iZiI6MTY4OTg1Mzk0NiwiZXhwIjoxNzIxNDc2MzQ2LCJzdWIiOiIxMiIsInNjb3BlcyI6W119.FBVXv3ilHKnz0t_I5B1tg54kjwVzM59PMIVCH5F7NZtwqxumiq2I8HsNajHw1w-2oVxlkgHZHvHAx9TmlAJFC55ffdNo3URC3At4_nqMPMsJ2IhO-1FXEqX5iDGN7F3Fr42chvNw3caB7dNBG207zgpJm7XpK-18iqVm6oW034hwKHg8uHz8BhPd_0DW8i9ouQf0RI7BW-W6Q6tQtNyIcLwLrLunQtzAci4rqDaOViESqiCL8bb0ZLtNAtY_DsbLUzOQ1NJF5R9xLhH_yughbeNEdmQgKjuueDBKkiPWvqxZX4GdqtvZKxt4ZgpAHR2m8CvhYWL2HbwmSl9TiYDAvKcAi8gGgI06HodxToP1j2KftfG2c4tTrJ9i2hGbD9o7eV12EQ0ZnMbBdyCc-5GW-hxXoz3j1PDyBRzVGYquihseVoIuOuk_6NieVwc0a7DOJOlpt4nJjttdRQGt5D9f_0_LB89pUwUXuJIKQ5DKWVPpT6PrX5YHxwa4rIDC3_8mXcT6w9qF2TbQwjU7K-baRanWqpHZT9v-d0Mc2GA2aGIIAl_urhGcMLDiMwkEv15OcZ5pBn190s4M0HcoelVKis7cf4PeOcBkgAPUfml-yJlNUWOnFNYVABI0wjdj0NrYki5vLdNt8ZoVsQ9PyNBRWD0815tSmGbVkILJEdvJ-vc"; // Apna token yahan par daalein
    const headers = {
      'Authorization': `Bearer ${token}`
    };
    try {
      const response = await axios.post(url, payload, { headers });
      console.log("api browser value response", response);

      if (response.status == true) {
        let ttt = response?.data
        let incriptedDataStore = incrpted([ttt])
        response?.status && sessionStorage.setItem('userData', JSON.stringify(incriptedDataStore));

        localStorage.setItem("webinarpopup", "yes");
        // response?.status && localStorage.setItem("userData", JSON.stringify(incriptedDataStore))
        navigate("/console")

        // response?.status && localStorage.setItem("userData", JSON.stringify(ttt))
      } else {

      }

    } catch (error) {
      // Handle error here
      console.error('Error:', error.message);
      return null;
    }
  };


  const handleVerifyOtp = () => {
    setOtpError("");
    if (!otp) {
      setOtpError("Please Enter otp");
      return
    }
    handleSubmit()
  };

  const handleSubmit = async () => {
    const url = `https://apinew.bigul.co/api/v1/verify-otp?username=${userId}&otp=${otp}`;
    // const headers = {
    //   'Authorization': `Bearer ${token}`
    // };

    try {
      const response = await axios.post(url, null,);
      if (response?.status == true) {
        setOtpResponse(response)
        let ttt = response?.data
        let incriptedDataStore = incrpted([ttt])
        // response?.status && localStorage.setItem("userData", JSON.stringify(incriptedDataStore))
        response?.status && sessionStorage.setItem('userData', JSON.stringify(incriptedDataStore));
        // response?.status && localStorage?.setItem("userData", JSON.stringify(ttt))
        // logEvent(analytics, 'otp_success_attempt', {
        //   method: 'email', event: "login_btn", page_title: "SignUp Page",
        //   screen_name: "SignUpScreen",
        // });
        localStorage.setItem("webinarpopup", "yes");
        navigate("/console")
        // return response.data;
      } else {
        setOtpError(response);

      }

    } catch (error) {
      // Handle error here
      console.error('Error:', error.message);
      return null;
    }
  };

  const remaingSecondConditions = () => {
    setOtp('')
    setSecondsRemaining(30);
    setTimerStart(true);
    dispatch(
      postLogin({
        username: userId,
      })
    );
    // logEvent(analytics, 'resend_otp_attempt', {
    //   method: 'email',
    //   event: "resend_otp_attempt", page_title: "SignUp Page",
    //   screen_name: "SignUpScreen",
    // });

  }
  const emptyLoginDetails = () => {
    setUserId("")
    setOtp("")
    dispatch(removeLoginData())
  }
  const handleClick = (event) => {
    event.preventDefault();
    callWebView();
  };

  const callWebView = () => {
    const url = 'https://dkyc.bigul.co/'
    window.open(url, '_blank');
  };

  const becomePatner = () => {
    const url = 'https://bigul.co/partners'
    window.open(url, '_blank');
  }

  console.log(loginDeatil?.logingData?.mobile);
  return (
    <React.Fragment>
      {location.search.includes("UserName") ?

        <img src={loaderImg} alt="Loading..." className='loader-img ' style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '150px',
          height: 'auto',
        }} />
        :
        <div className="login-wraper">
          <div className="banner-part">
            <img src={ImagePath.image} />
          </div>
          <div className="text-part">
            <div className="logo-header">
              <a href="#">
                {/* <img src={ImagePath.logo_patner} /> */}
                <img src={ImagePath.bonanza} />
              </a>
            </div>
            <div className="login-box">
              <h3 className="title-1">Login to Business Ambassador Console</h3>
              {/* Code Partner screen conditions manage*/}
              {loginDeatil?.logingData?.mobile ?
                <></>
                :
                <div className="form-box">
                  <div className="form-group">
                    <label><img src={ImagePath.partnerCodeIcon} /> BA Code</label>
                    <input type="text" name="" className="form-control" placeholder="Enter BA code" onChange={handleUserId} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginRight: '10px' }}>
                    <p className="para">We will send you the OTP on your mobile number.</p>
                    <p style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={becomePatner}>Become a Business Ambassador</p>
                  </div>
                  <div className="Login-text-4" style={{ color: 'red', marginTop: "2px" }}>{loginDeatil?.logingData?.status == false ? loginDeatil?.logingData?.message : errorId} {loginDeatil?.logingData?.is_mobile === false
                    && (
                      <span
                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={handleClick}
                      >
                        Update now
                      </span>
                    )}
                  </div>
                  <button className="send-btn" style={{ marginTop: "25px" }} onClick={() =>
                    handleContinue()
                    // handleClickEvent()
                  }>Send OTP</button>
                </div>
              }
              {/* otp screen conditions manage*/}
              {loginDeatil?.logingData?.mobile ?
                <div className="form-box">
                  <div className="otp-field">
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      inputType="number"
                      renderInput={(props) => <input {...props} onWheel={(e) => e.target.blur()} />}
                    />
                  </div>
                  <p className="para">Enter OTP sent to your register mobile number <span>{(loginDeatil?.logingData?.mobile).replace(/(\d{2})\d+(\d{2})/, "$1******$2")}</span></p>
                  <div className="Login-text-4" style={{ color: 'red', marginTop: "2px" }}>{otpError.status == false ? otpError.message : otp !== "" ? "" : otpError}</div>
                  <div onClick={() => {
                    if (secondsRemaining == 0) {
                      remaingSecondConditions()
                    }
                  }}>
                    <a href="#" class="resend">
                      {secondsRemaining === 0
                        ? "Resend OTP" // Show "Resend" when countdown is 0
                        : `Resend in (00:${secondsRemaining < 10 ? `0${secondsRemaining}` : secondsRemaining
                        })`}
                      {/* Resend in (00:{secondsRemaining}) */}
                    </a></div>
                  <button className="send-btn" onClick={() => handleVerifyOtp()}>Verify</button>
                  <button className="back-btn" onClick={() => emptyLoginDetails()}>back</button>
                  {/* <a href="#" className="update_mobile" onClick={handleClick}>Update Mobile Number</a> */}

                </div>
                :
                <></>
              }
            </div>
            {/* status bar manage conditions apply */}

            <div className="status-bar">
              <div className={loginDeatil?.logingData?.mobile ? "bar " : "bar active"}></div>
              <div className={loginDeatil?.logingData?.mobile ? "bar active" : "bar "}></div>
            </div>

          </div>
        </div>

      }
    </React.Fragment>

  );
}

export default LoginScreen;
